import { ReactNode } from "react";

interface TitlePageProps {
  children: ReactNode;
}
export default function TitlePage({ children }: TitlePageProps) {
  return <h1 className="flex items-center gap-4">{children}</h1>;
}
